export const BDXStatusPendingManagerInjectionKey = 'bdx-status-pending-manager'
